import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const kajeEntry = createAsyncThunk('kajeEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertKajeEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});



export const fetchStitchReturnOptions = createAsyncThunk('fetchStitchReturnOptions', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStitchOptionslist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchKajeOptions = createAsyncThunk('fetchKajeOptions', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getKajeOptionslist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPressEmplist = createAsyncThunk('fetchPressEmplist', async (id) => {
    try {
        const endpoint = id ? `getPressEmplist&empId=${id}` : 'getPressEmplist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPressMemoNo = createAsyncThunk('fetchPressMemoNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPressMemoNo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPressRegProduction = createAsyncThunk('fetchPressRegProduction', async (id) => {
    try {
        const endpoint = id ? `getPressRegister&prId=${id}` : 'getPressRegister';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const PressApiSlice = createSlice({
    name: 'PressDatalist',
    initialState: {
        isLoading: false,
        sreMemo: null,
        kreMemo: null,
        emplist: null,
        prMemo: null,
        prlist: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchStitchReturnOptions.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchReturnOptions.fulfilled, (state, action) => {
            state.isLoading = false;
            state.sreMemo = action.payload;
        });
        builder.addCase(fetchStitchReturnOptions.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchKajeOptions.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchKajeOptions.fulfilled, (state, action) => {
            state.isLoading = false;
            state.kreMemo = action.payload;
        });
        builder.addCase(fetchKajeOptions.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPressEmplist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPressEmplist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.emplist = action.payload;
        });
        builder.addCase(fetchPressEmplist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPressMemoNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPressMemoNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.prMemo = action.payload;
        });
        builder.addCase(fetchPressMemoNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPressRegProduction.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPressRegProduction.fulfilled, (state, action) => {
            state.isLoading = false;
            state.prlist = action.payload;
        });
        builder.addCase(fetchPressRegProduction.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

    }
});

export default PressApiSlice.reducer;
